var VersionInterceptor = (function () {
    function VersionInterceptor($q, websiteConfiguration) {
        var _this = this;
        this.$q = $q;
        this.websiteConfiguration = websiteConfiguration;
        this.request = function (config) {
            if (config.url.indexOf('api/') > -1 || /ng-(translation|settings|pages)/gi.test(config.url)) {
                config.url += (config.url.indexOf('?') > -1 ? '&' : '?') + ("version=" + _this.websiteConfiguration.version);
            }
            return config || _this.$q.when(config);
        };
    }
    VersionInterceptor.Factory = function ($q, websiteConfiguration) {
        return new VersionInterceptor($q, websiteConfiguration);
    };
    return VersionInterceptor;
}());
export { VersionInterceptor };
